
export default function Services() {
  const openWhatsApp = () => {
    const message = encodeURIComponent('Olá! Gostaria de saber mais sobre os serviços da DataPrec para precatórios e RPV. Podem me ajudar?');
    window.open(`https://wa.me/5531981041870?text=${message}`, '_blank');
  };

  const services = [
    {
      title: "Automação Inteligente",
      description: "Sistemas que coletam e organizam dados automaticamente, otimizando tempo e custos operacionais.",
      image: "https://readdy.ai/api/search-image?query=Modern%20automated%20data%20processing%20system%20with%20robotic%20arms%20handling%20digital%20information%2C%20sleek%20technology%20interface%20with%20blue%20and%20dark%20navy%20color%20scheme%2C%20professional%20business%20automation%20concept%2C%20clean%20minimalist%20design%2C%20high-tech%20atmosphere&width=400&height=240&seq=automation-service-v2&orientation=landscape",
      gradient: "from-blue-600 to-indigo-700"
    },
    {
      title: "Leads Segmentados",
      description: "Informações precisas e confiáveis para empresas, investidores e escritórios de advocacia.",
      image: "https://readdy.ai/api/search-image?query=Professional%20business%20analytics%20dashboard%20showing%20segmented%20customer%20data%20and%20lead%20generation%20metrics%2C%20modern%20interface%20with%20charts%20and%20graphs%2C%20dark%20blue%20corporate%20color%20scheme%2C%20sophisticated%20data%20visualization%20with%20target%20audience%20analysis&width=400&height=240&seq=leads-service-v2&orientation=landscape",
      gradient: "from-indigo-600 to-purple-700"
    },
    {
      title: "Análise de Dados",
      description: "Inteligência de dados para identificar oportunidades de investimento com alto potencial de conversão.",
      image: "https://readdy.ai/api/search-image?query=Advanced%20data%20analysis%20visualization%20with%20interactive%20charts%2C%20graphs%20and%20predictive%20analytics%20on%20multiple%20screens%2C%20professional%20business%20intelligence%20environment%2C%20dark%20blue%20and%20navy%20color%20palette%2C%20modern%20tech%20workspace%20with%20investment%20analysis&width=400&height=240&seq=analytics-service-v2&orientation=landscape",
      gradient: "from-purple-600 to-pink-700"
    },
    {
      title: "Soluções Sob Medida",
      description: "Desenvolvemos automatizações personalizadas para acelerar processos de tomada de decisão.",
      image: "https://readdy.ai/api/search-image?query=Custom%20software%20development%20workspace%20with%20multiple%20monitors%20showing%20code%20and%20business%20applications%2C%20modern%20tech%20office%20environment%2C%20professional%20developers%20working%20on%20tailored%20solutions%2C%20dark%20blue%20corporate%20aesthetic%20with%20custom%20dashboards&width=400&height=240&seq=custom-service-v2&orientation=landscape",
      gradient: "from-cyan-600 to-blue-700"
    }
  ];

  return (
    <section id="servicos" className="py-20 bg-gradient-to-br from-gray-50 to-blue-50">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-6">Nossos Serviços</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Soluções completas em tecnologia e inteligência de dados para o mercado de precatórios e RPV
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {services.map((service, index) => (
            <div 
              key={index}
              className="group bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2"
            >
              {/* Image */}
              <div className="relative h-48 overflow-hidden">
                <img 
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover object-center group-hover:scale-110 transition-transform duration-500"
                />
                <div className={`absolute inset-0 bg-gradient-to-t ${service.gradient} opacity-20 group-hover:opacity-30 transition-opacity duration-300`}></div>
              </div>

              {/* Content */}
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-blue-700 transition-colors">
                  {service.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {service.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* CTA Section */}
        <div className="mt-16 text-center">
          <div className="bg-gradient-to-r from-blue-600 to-indigo-700 rounded-2xl p-8 text-white">
            <h3 className="text-2xl font-bold mb-4">Pronto para transformar seus dados?</h3>
            <p className="text-blue-100 mb-6 max-w-2xl mx-auto">
              Descubra como nossas soluções podem otimizar seus processos e acelerar seus resultados
            </p>
            <button 
              onClick={openWhatsApp}
              className="bg-white text-blue-700 px-8 py-3 rounded-lg font-semibold hover:bg-blue-50 transition-colors cursor-pointer whitespace-nowrap"
            >
              Fale Conosco
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
